import {
  ArrowsRightLeftIcon,
  Bars2Icon,
  CalendarIcon,
  CheckIcon,
  DocumentArrowUpIcon,
  DocumentTextIcon,
  VideoCameraIcon,
  XMarkIcon
} from "@heroicons/vue/24/solid/index";

export const SCREENING_QUESTION_TYPE_TEXT = "text";
export const SCREENING_QUESTION_TYPE_VIDEO = "video";
export const SCREENING_QUESTION_TYPE_TEXT_OR_VIDEO = "text_or_video";
export const SCREENING_QUESTION_TYPE_TEXTAREA = "textarea";
export const SCREENING_QUESTION_TYPE_SELECT = "select";
export const SCREENING_QUESTION_TYPE_MULTISELECT = "multiselect";
export const SCREENING_QUESTION_TYPE_DATE = "date";
export const SCREENING_QUESTION_TYPE_FILE = "file";
export const SCREENING_QUESTION_TYPE_KNOCKOUT = "knockout";

const typeTextOnly = {
  iconIsComponent: true,
  icon: Bars2Icon,
  title: "Text",
  description: "A short, paragraph-length textbox.",
  value: SCREENING_QUESTION_TYPE_TEXT,
  iconClasses: "text-bdBlue-600 h-4 w-4 self-center min-w-[1rem]"
};

const typeVideoOnly = {
  iconIsComponent: true,
  icon: VideoCameraIcon,
  title: "Video",
  description: "A video recording up to 60 seconds.",
  value: SCREENING_QUESTION_TYPE_VIDEO,
  iconClasses: "text-bdPurple-600 h-4 w-4 self-center min-w-[1rem]"
};

const typeTextOrVideo = {
  iconIsComponent: true,
  icon: ArrowsRightLeftIcon,
  title: "Text or Video",
  description: "Allow candidate to provide either text or video.",
  value: SCREENING_QUESTION_TYPE_TEXT_OR_VIDEO,
  iconClasses: "text-bdRed-600 h-4 w-4 self-center min-w-[1rem]"
};

const typeTextarea = {
  iconIsComponent: true,
  icon: DocumentTextIcon,
  title: "Long Text",
  description: "A long, multi-line textbox.",
  value: SCREENING_QUESTION_TYPE_TEXTAREA,
  iconClasses: "text-bdOrange-600 h-4 w-4 self-center min-w-[1rem]"
};

const typeSelect = {
  iconIsComponent: true,
  icon: CheckIcon,
  title: "Single Select",
  description: "A single-select dropdown.",
  value: SCREENING_QUESTION_TYPE_SELECT,
  iconClasses: "text-bdYellow-600 h-4 w-4 self-center min-w-[1rem]"
};

const typeMultiselect = {
  iconIsComponent: true,
  icon: CheckIcon,
  title: "Multi-select",
  description: "A multi-select dropdown.",
  value: SCREENING_QUESTION_TYPE_MULTISELECT,
  iconClasses: "text-bdBlue-600 h-4 w-4 self-center min-w-[1rem]"
};

const typeDate = {
  iconIsComponent: true,
  icon: CalendarIcon,
  title: "Date",
  description: "A date picker.",
  value: SCREENING_QUESTION_TYPE_DATE,
  iconClasses: "text-bdPurple-600 h-4 w-4 self-center min-w-[1rem]"
};

const typeFile = {
  iconIsComponent: true,
  icon: DocumentArrowUpIcon,
  title: "Document Upload",
  description: "Request documents, certificates, or licenses.",
  value: SCREENING_QUESTION_TYPE_FILE,
  iconClasses: "text-bdRed-500 h-4 w-4 self-center min-w-[1rem]"
};

const typeKnockout = {
  iconIsComponent: true,
  icon: XMarkIcon,
  title: "Knockout Question",
  description: "Immediately disqualify candidates based on their response.",
  value: SCREENING_QUESTION_TYPE_KNOCKOUT,
  iconClasses: "text-bdRed-600 h-4 w-4 self-center min-w-[1rem]"
};

export const SCREENING_QUESTION_TYPES_WITH_ICONS = [
  typeTextOnly,
  typeVideoOnly,
  typeTextOrVideo,
  typeFile,
  typeTextarea,
  typeSelect,
  typeMultiselect,
  typeDate,
  typeKnockout,
];

export const KNOCKOUT_OPTIONS_WITH_ICONS = [
  typeSelect,
  typeMultiselect,
  typeDate
];

export const DATE_COMPARISON_OPTIONS = [
  {
    value: "<",
    name: "Before"
  },
  {
    value: ">",
    name: "After"
  },
];

export const TYPE_PLACEHOLDERS = {
  "text": "e.g. What makes you a good fit for this role?",
  "video": "e.g. Why are you interested in this role?",
  "text_or_video": "e.g. Why are you interested in this role?",
  "file": "e.g. Upload your professional license or certification",
  "textarea": "e.g. Tell us about a time you had to solve a difficult problem.",
  "select": "e.g. Do you have a car?",
  "multiselect": "e.g. Which of the following tools do you have experience with?",
  "date": "e.g. When are you available to start?",
  "knockout": "e.g. Can you work Saturdays after 6pm?"
};
